<template>
  <List class="px-3 overflow-x-auto" finished-text="没有更多了">
    <div
      v-for="item in goodsList"
      :key="item.goodsId"
      class="flex flex-row mb-3 items-center"
    >
      <div
        class="flex-shrink-0 flex-grow-0 rounded-md overflow-hidden"
        style="height: 116px; width: 116px"
        @click="goGoodsDetail(item.partGoodsId)"
      >
        <img class="w-full h-full" :src="item.goodsImg" alt="" />
      </div>

      <div class="flex-grow flex flex-col ml-2 text-left">
        <div
          class="text-sm overflow-y-auto"
          style="max-height: 3rem"
          @click="goGoodsDetail(item.partGoodsId)"
        >
          <span>标签 </span><span>{{ item.goodsName }}</span>
        </div>
        <div :class="item.status === 'green' ? 'opacity-100' : 'opacity-0'">
          <div
            style="color: #44d7b6; background-color: #d7fbf3"
            class="text-xxs inline-block float-left rounded-full px-3"
          >
            02月04日08:00开售
          </div>
        </div>
        <div class="-mt-1">
          <span class="font-semibold">¥</span
          ><span class="font-semibold text-2xl mr-1">{{ item.actPrice }}</span
          ><span class="text-red font-semibold text-sm"
            >省赚<span class="text-base">{{ item.saveProfit }}</span
            >元</span
          >
        </div>
        <div class="flex justify-between -mt-1">
          <div class="flex items-center flex-shrink-0">
            <span
              class="text-xxs -ml-1"
              style="
                width: 100px;
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              "
            >
              {{ item.actName }}
            </span>
            <Icon name="arrow" />
          </div>
          <div class="flex flex-row items-center flex-shrink-0">
            <div
              class="flex items-center mr-1"
              @click="
                $router.push({
                  name: 'GoodsDetail',
                  params: { id: item.partGoodsId, showCart: true },
                })
              "
            >
              <img
                :src="
                  item.status === 'green'
                    ? require('@/assets/brandplace/greencart.svg')
                    : require('@/assets/brandplace/redcart.svg')
                "
                alt=""
              />
            </div>
            <div
              class="
                inline-block
                text-white
                rounded-full
                py-1
                px-2
                text-xs text-center
              "
              style="width: 5rem; max-height: 29px"
              :style="
                item.status === 'green'
                  ? 'background-color:#44D7B6'
                  : 'background-color:#E82035'
              "
              @click="showDiag(item)"
            >
              分享赚&nbsp;<img
                class="inline"
                style="height: 1rem"
                src="@/assets/brandplace/forward.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Overlay
      :show="diagVisible"
      @click="
        () => {
          diagVisible = false;
          showShare = false;
        }
      "
    >
      <div
        v-show="!showShare"
        class="wrapper mx-12"
        :class="showInput ? '-my-2' : 'my-12'"
        @click.stop
      >
        <div class="bg-white rounded-lg mb-6 overflow-auto p-3 text-left">
          <div class="flex items-center mb-2">
            <div style="height: 46px; width: 46px" class="flex-shrink-0 mr-3">
              <img
                :src="forwardDetail.logoUrl"
                class="h-full w-full rounded"
                alt=""
              />
            </div>
            <div class="flex flex-col">
              <div class="text-xs font-semibold">
                {{ forwardDetail.activityName }}
              </div>
              <div class="text-xs">{{ forwardDetail.brandName }}</div>
            </div>
          </div>
          <div class="flex justify-center">
            <div style="height: 182px; width: 182px" class="mr-1">
              <img
                :src="forwardDetail.posterImg"
                class="h-full w-full rounded"
                alt=""
              />
            </div>
            <div class="flex flex-col justify-between">
              <img
                style="height: 89px; width: 89px"
                :src="forwardDetail.rightImgOne"
                alt=""
                class="rounded"
              />
              <img
                style="height: 89px; width: 89px"
                :src="forwardDetail.rightImgTwo"
                alt=""
                class="rounded"
              />
            </div>
          </div>
          <div class="text-xs py-1">
            {{ forwardDetail.goodsName }}
          </div>
          <div
            v-if="forwardDetail.specDetailList"
            class="text-xs"
            :class="
              forwardDetail.specDetailList.length ? 'opacity-0' : 'opacity-100'
            "
          >
            规格:{{
              forwardDetail.specDetailList
                ? forwardDetail.specDetailList.join("/")
                : ""
            }}
          </div>
          <div class="flex justify-between mb-3">
            <div class="text-red">
              <span class="text-xs">¥</span
              ><span class="font-semibold mr-2">{{ forwardDetail.price }}</span
              ><span class="text-xxs font-semibold"
                >赚：{{ forwardDetail.saveProfit }}元</span
              >
            </div>
            <div class="text-xs">
              {{
                dayjs(forwardDetail.activityTime).format("MM[月]DD[日] HH:mm")
              }}结束
            </div>
          </div>
          <div>
            <div class="text-xs">加价：</div>
            <div class="flex justify-between text-xs -mx-1 mb-2">
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 1 }"
                @click="() => (jiajiaway = 1)"
              >
                不加价
              </div>
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 2 }"
                @click="() => (jiajiaway = 2)"
              >
                加价10元
              </div>
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 3 }"
                @click="() => (jiajiaway = 3)"
              >
                加价20%
              </div>
            </div>
            <div>
              <Field
                class="rounded h-8 pt-1"
                style="background-color: #f1f1f1"
                placeholder="自定义金额"
                input-align="center"
                readonly
                clickable
                :value="customjiajia"
                @touchstart.native.stop="
                  () => {
                    jiajiaway = 4;
                    showInput = true;
                  }
                "
              />
            </div>
          </div>

          <NumberKeyboard
            v-model="customjiajia"
            :show="showInput"
            theme="custom"
            extra-key="."
            close-button-text="完成"
            @blur="showInput = false"
          />
        </div>
        <Button
          style="height: 2rem"
          round
          color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
          size="large"
          v-gapclick="generatePost"
          >生成海报</Button
        >
      </div>
    </Overlay>
  </List>
</template>

<script>
import {
  Icon,
  List,
  Button,
  Overlay,
  NumberKeyboard,
  Field,
  Image as VImage,
} from "vant";
import { priceMarkup, forwardDetail } from "@/api/forward.js";
export default {
  components: {
    Icon,
    List,
    Button,
    Overlay,
    NumberKeyboard,
    Field,
  },
  props: { goodsList: { type: Array, default: () => [] } },

  data() {
    return {
      forwarding: null,
      forwardDetail: {},
      diagVisible: false,
      showInput: false,
      customjiajia: "",
      jiajiaway: 1,
      urlAddress: null,
      showShare: false,

      browserType: localStorage.getItem("browserType"),
    };
  },
  methods: {
    showDiag(item) {
      this.forwarding = item;
      forwardDetail({
        actId: this.forwarding.actId,
        partId: this.forwarding.partId,
        partGoodsId: this.forwarding.partGoodsId,
        goodsId: this.forwarding.goodsId,
        suitId: null,
        customerId: null,
        retailId: null,
        forwardType: "GOODS",
      }).then(({ data }) => {
        this.forwardDetail = data;
        this.diagVisible = true;
      });
    },
    goGoodsDetail(id) {
      this.$router.push({ name: "GoodsDetail", params: { id } });
    },

    generatePost() {
      let urlAddress;
      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          location.pathname +
          "?customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.href + "?customerId=" + this.$store.state.user.forwardId;
      }
      let params = {
        actId: this.forwarding.actId,
        partId: this.$route.query.partId,
        partGoodsId: this.forwarding.partGoodsId,
        goodsId: this.forwarding.goodsId,
        retailId: null,
        markupType: "NONE",
        markupAmount: 0,
        markupRatio: 0,
        forwardType: "GOODS",
        price: 0,
        urlAddress,
      };
      switch (this.jiajiaway) {
        case 1:
          params.markupType = "NONE";
          params.price = this.forwarding.actPrice;
          break;
        case 2:
          params.markupType = "AMOUNT";
          params.markupAmount = 10;
          params.price = this.forwarding.actPrice + 10;
          break;
        case 3:
          params.markupType = "RATIO";
          params.markupRatio = 0.2;
          params.price = this.forwarding.actPrice * 1.2;
          break;
        case 4:
          if (!this.customjiajia) {
            return;
          }
          params.markupType = "AMOUNT";
          params.markupAmount = Number(this.customjiajia);
          params.price = this.forwarding.actPrice + Number(this.customjiajia);

          break;
        default:
          break;
      }
      this.urlAddress = urlAddress;
      console.log(params);
      priceMarkup(params).then(({ data }) => {
        // this.showShare = true;
        this.diagVisible = false;
        this.$store.dispatch("sharePoster/show", {
          url: data.url,
          title: this.forwarding.goodsName,
          desc: "",
          link: urlAddress,
          imgUrl: this.forwarding.goodsImg,
        });
      });
    },
  },
};
</script>

<style scoped>
</style>